import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid breadcrumb-page" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexBreadcrumb',
  setup(__props) {

const DefaultBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/DefaultBreadcrumb.vue"))
const DividersBreadcrumbs = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/DividersBreadcrumbs.vue"))
const IconsBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/IconsBreadcrumb.vue"))
const NavBreadcrumb = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/NavBreadcrumb.vue"))
const BreadcrumbAlignment = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/BreadcrumbAlignment.vue"))
const ColoredNavigation = defineAsyncComponent(() => import("@/components/theme/advance/breadcrumb/ColoredNavigation.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Breadcrumb",
      title: "Breadcrumb"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(DefaultBreadcrumb)),
        _createVNode(_unref(DividersBreadcrumbs)),
        _createVNode(_unref(IconsBreadcrumb)),
        _createVNode(_unref(NavBreadcrumb)),
        _createVNode(_unref(BreadcrumbAlignment)),
        _createVNode(_unref(ColoredNavigation))
      ])
    ])
  ], 64))
}
}

})